import React, { useEffect } from 'react';
import { HiOutlineDeviceMobile } from 'react-icons/hi';
import { ExternalChannelConfig } from '../../../../../../types/communication';
import SectionCard from '../../shared/SectionCard';
import FixedRecipientField from '../../shared/FixedRecipientField';
import { recipientToken } from '../recipientVariable';

interface WhatsAppDeliveryProps {
    config: ExternalChannelConfig;
    disabled: boolean;
    onChange: (config: ExternalChannelConfig) => void;
}

const PHONE_RECIPIENT_TOKEN = recipientToken('EXTERNAL_MESSAGE');

const WhatsAppDelivery: React.FC<WhatsAppDeliveryProps> = ({ config, disabled, onChange }) => {
    useEffect(() => {
        if (disabled) return;
        if (config.to.length === 0) {
            onChange({ ...config, to: [PHONE_RECIPIENT_TOKEN] });
        }
    }, [disabled, config, onChange]);

    return (
        <SectionCard
            title="Para quem vai"
            description="O telefone do destinatário é preenchido automaticamente a cada envio."
            icon={<HiOutlineDeviceMobile size={18} />}
        >
            <FixedRecipientField
                label="Telefone de destino"
                token={PHONE_RECIPIENT_TOKEN}
                hint="Preenchido automaticamente com o celular do destinatário de cada envio."
            />
        </SectionCard>
    );
};

export default WhatsAppDelivery;
